export default __webpack_public_path__ + "static/media/US.3282780c.svg";